import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';
import { ResourceAllocationType, ResourceAllocationStatus } from '~/types';
import {
  specificResourceAllocationFragment,
  specificResourceAllocationUserFragment
} from '~/modules/resourcing/common/fragments';

export const ALLOCATIONS_QUERY = gql`
  query Eager_GetAllocations(
    $projectUri: String
    $userUri: String
    $filter: ResourceAllocationFilter
    $allocationStatusList: [ResourceAllocationStatus!]
  ) {
    resourceAllocations(
      projectUri: $projectUri
      userUri: $userUri
      filter: $filter
      allocationStatusList: $allocationStatusList
    ) {
      resourceAllocations {
        ...SpecificResourceAllocation
        role {
          uri
          id
          displayText
        }
        user {
          ...SpecificResourceAllocationUser
        }
      }
    }
  }
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUserFragment}
`;

const useGetExistingRoleUserAllocations = ({
  roleUri,
  projectUri,
  userUri
}) => {
  const variables = {
    filter: {
      roles: [roleUri],
      allocationType: ResourceAllocationType.Direct
    },
    projectUri,
    userUri,
    allocationStatusList: [ResourceAllocationStatus.Committed]
  };

  const { data, loading } = useQuery(ALLOCATIONS_QUERY, {
    variables,
    fetchPolicy: 'cache-and-network'
  });

  return {
    resourceAllocations: data?.resourceAllocations?.resourceAllocations,
    isLoading: loading
  };
};

export default useGetExistingRoleUserAllocations;
